var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('ui-update-info',{staticClass:"wrapper",attrs:{"data":_vm.updateInfo}})],1),_c('Card',[_c('ui-update-info',{staticClass:"wrapper",attrs:{"data":_vm.updateInfo,"infoFormat":"short"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }